<template>
  <div>
    <div class="form-control">
      <label for="cf_cep">CEP*:</label>
      <input id="cf_cep" name="cf_cep" v-mask="'#####-###'" required="true" ref="cepInput" v-model="dadosEndereco.cep"
        @blur="validateCEP(true)" @input="validateCEP(false)" />
      <span v-if="cepError" class="error-message">{{ cepError }}</span>
    </div>
    <div class="form-control">
      <label for="cf_endereco">Endereço*:</label>
      <input id="cf_endereco" name="cf_endereco" required="true" />
    </div>
    <div class="form-control">
      <label for="cf_numero">Número*:</label>
      <input id="cf_numero" name="cf_numero" required="true" />
    </div>
    <div class="form-control">
      <label for="cf_complemento">Complemento:</label>
      <input id="cf_complemento" name="cf_complemento" maxlength="15" />
    </div>
    <div class="form-control">
      <label for="cf_bairro">Bairro*:</label>
      <input id="cf_bairro" name="cf_bairro" required="true" />
    </div>
    <div class="form-control">
      <label for="cf_estado">Estado*:</label>
      <select name="cf_estado" id="cf_estado" @change="load_municipios" required="true">
        <option value=""></option>
        <option :value="uf.sigla" v-for="(uf, index) in ufs" v-bind:key="index">
          {{ uf.sigla }} - {{ uf.nome }}
        </option>
      </select>
    </div>
    <div class="form-control">
      <label for="cf_cidade">Cidade*:</label>
      <select name="cf_cidade" id="cf_cidade">
        <option value="">Selecione um estado primeiro</option>
        <option :value="`${municipio.id} - ${municipio.nome}`" v-for="(municipio, index) in municipios" v-bind:key="index">
          {{ municipio.nome }}
        </option>
      </select>
    </div>
    <div class="form-control">
      <label for="cf_estado_nascimento">Estado de Nascimento*:</label>
      <select name="cf_estado_nascimento" id="cf_estado_nascimento" @change="load_municipios_nascimento"
        v-model="dadosDocumentacao.estado_nascimento" required="true">
        <option value=""></option>
        <option value="EX">EX - Exterior</option>
        <option v-for="(uf, index) in ufs" :key="index" :value="uf.sigla">
          {{ uf.sigla }} - {{ uf.nome }}
        </option>
      </select>
    </div>
    <div class="form-control" v-if="dadosDocumentacao.estrangeiro == 'nao'">
      <label for="cf_cidade_nascimento">Cidade de Nascimento*:</label>
      <select name="cf_cidade_nascimento" id="cf_cidade_nascimento" v-model="dadosDocumentacao.cidade_nascimento">
        <option value="">Selecione um estado primeiro</option>
        <option v-for="(mun, index) in municipios_nascimento" :key="index" :value="mun.id">
          {{ mun.nome }}
        </option>
      </select>
    </div>

    <!-- <div class="form-control">
            <label for="cf_telefone_pessoal">Telefone pessoal*:</label>
            <input id="cf_telefone_pessoal" name="cf_telefone_pessoal" v-mask="['(##) ####-####', '(##) #####-####']" type="tel" required="true">
        </div> -->
    <div class="form-control">
      <label for="cf_telefone_celular">Telefone celular:</label>
      <input id="cf_telefone_celular" name="cf_telefone_celular" v-mask="['(##) ####-####', '(##) #####-####']"
        type="tel" />
    </div>
    <div class="form-control">
      <label for="cf_Telefone_emergencia">Telefone de emergência:</label>
      <input id="cf_Telefone_emergencia" name="cf_Telefone_emergencia" v-mask="['(##) ####-####', '(##) #####-####']"
        type="tel" />
    </div>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import mixins from "@/assets/mixins";

export default {
  directives: { mask },
  mixins: [mixins],
  props: {
    candidatoDb: Object,
    dadosDocumentacao: Object,
    dadosEndereco: Object,
  },
  watch: {
    "dadosDocumentacao.estrangeiro"(valor) {
      if (valor === "sim") {
        this.dadosDocumentacao.estado_nascimento = "EX";
      } else if (
        valor === "nao" &&
        this.dadosDocumentacao.estado_nascimento === "EX"
      ) {
        this.dadosDocumentacao.estado_nascimento = "";
      }
    },
  },
  data: () => ({
    ufs: [],
    todos_municipios: [],
    municipios: [],
    municipios_nascimento: [],
    // dadosDocumentacao: {
    //   estrangeiro: "",
    //   estado_nascimento: "",
    //   cidade_nascimento: "",
    // },
    cepError: "",
  }),
  mounted() {
    // Carrega os estados
    const interval = setInterval(() => {
      this.ufs = this.$store.state.ufs;

      if (this.ufs && this.ufs.length > 0) {
        clearInterval(interval);
      }
    }, 1000);

    const interval2 = setInterval(() => {
      this.todos_municipios = this.$store.state.municipios || [];
      this.municipios = this.$store.state.municipios || [];
      this.municipios_nascimento = this.$store.state.municipiosNascimento || [];

      if (this.municipios && this.municipios.length > 0) {
        clearInterval(interval2);
      }
    }, 1000);
  },
  methods: {
    getMunicipiosByUf(uf) {
      return (this.todos_municipios || []).filter((municipio) => {
        const ufSigla =
          municipio?.microrregiao?.mesorregiao?.UF?.sigla ||
          municipio?.uf?.sigla ||
          municipio?.sigla_uf ||
          municipio?.uf_sigla;

        return ufSigla === uf;
      });
    },
    load_municipios(el) {
      const uf = el.target.value;
      const municipios = this.getMunicipiosByUf(uf);

      if (!uf) {
        this.municipios = [];
        return;
      }

      if (municipios.length === 0) {
        console.warn(`[load_municipios] nenhum municipio encontrado para a UF ${uf}`);
      }

      this.municipios = this.orderStr(municipios, "nome");
    },

    load_municipios_nascimento(el) {
      const uf = el.target.value;
      const municipios = this.getMunicipiosByUf(uf);

      if (!uf || uf === "EX") {
        this.municipios_nascimento = [];
        return;
      }

      if (municipios.length === 0) {
        console.warn(
          `[load_municipios_nascimento] nenhum municipio encontrado para a UF ${uf}`
        );
      }

      this.municipios_nascimento = this.orderStr(municipios, "nome");
    },
    validateCEP(focusIfInvalid = false) {
      const cep = (this.dadosEndereco.cep || "").replace(/\D/g, "");

      // Regex para 8 dígitos
      const cepPattern = /^[0-9]{8}$/;

      if (!cepPattern.test(cep)) {
        this.cepError = "Por favor, insira um CEP válido com 8 números.";

        if (focusIfInvalid && this.$refs.cepInput) {
          this.$refs.cepInput.focus();
        }

        return false;
      }

      this.cepError = "";
      return true;
    },
  },
};
</script>
